import React from 'react';
import styled from 'styled-components';

const StyledImg = styled.img`
  width: ${(props: { isWide: boolean }) => (props.isWide ? 112 : 36)}px;
`;

interface Props {
  image: string;
  isWide: boolean;
}

export const ChatHeaderImage = (props: Props) => {
  const { image, isWide } = props;

  return (
    <div>
      <StyledImg isWide={isWide} alt="" src={image} />
    </div>
  );
};
